import React, { ReactNode } from 'react';
import { Text, Heading } from '@amzn/storm-ui';
import isString from 'lodash/isString';
import styled from 'styled-components';

const EmptyAndErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.large.default};
`;

type EmptyAndErrorContainerProps = {
  title: ReactNode;
  message: ReactNode;
};

const EmptyAndErrorContainer = ({
  title,
  message,
}: EmptyAndErrorContainerProps) => {
  return (
    <EmptyAndErrorWrapper>
      <Heading renderAs="h5">{title}</Heading>
      {isString(message) ? <Text>{message}</Text> : message}
    </EmptyAndErrorWrapper>
  );
};

export default EmptyAndErrorContainer;
